/* eslint quote-props: "off" */
export default {
  'Trend Explanation':                        'business_financial_and_underwriting',
  'Payoff Statements':                        'business_financial_and_underwriting',
  'Proof of Tax Filing':                      'business_financial_and_underwriting',
  'Credit Card Statements':                   'business_financial_and_underwriting',
  '2016 Proft and Loss':                      'business_financial_and_underwriting',
  '2016 Balance Sheet':                       'business_financial_and_underwriting',
  'Home Mortgage Statement':                  'business_financial_and_underwriting',
  'Mortgage Statement(s)':                    'business_financial_and_underwriting',
  'Pay Stub or W2':                           'business_financial_and_underwriting',
  'Projections':                              'business_financial_and_underwriting',
  'Tax Returns - 3rd year':                   'business_financial_and_underwriting',
  'Manual Tax Transcripts':                   'business_financial_and_underwriting',
  'Stamped Tax Return':                       'business_financial_and_underwriting',
  'Proof of Tax Extension':                   'business_financial_and_underwriting',
  'Affiliate Tax Return Last Year':           'business_financial_and_underwriting',
  'Affiliate Tax Return Prior Year':          'business_financial_and_underwriting',
  'Affiliate Tax Return 3rd Year':            'business_financial_and_underwriting',
  'Credit Memo (Revised)':                    'business_sba_forms_and_loan',
  'Old Phase I':                              'business_location',
  'Photos of Home Office':                    'business_location',
  'Use of Proceeds Explanation':              'business_use_of_proceeds',
  'Professional License':                     'business_entity',
  'DBA/ Fictitious Name Statement':           'business_entity',
  'Installment Agreement IRS':                'business_entity',
  'Proof of Tax Payment':                     'business_entity',
  'Building Insurance Coverage':              'business_insurance',
  'Malpractice Insurance':                    'business_insurance',
  'Business Insurance: Automobile Liability': 'business_insurance',
  'Proof of Affiliate Dissolution':           'business_affiliate',
  'Affiliate Good Standing':                  'business_affiliate'
}